<template>
  <comment-template
    :vbComment="vbComment"
    @downloadFile="downloadFile">
  </comment-template>
</template>

<script>
  import downloadService from "../../../services/downloadService";
  import CommentTemplate from "./comment-template";

  export default {
    name: "hc-command-comment",
    components: {CommentTemplate},
    props: ["vbComment"],

    methods: {
      downloadFile({vbAttachment}) {
        downloadService.downloadFileForAttachmentComment(vbAttachment.id);
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/adminstration/ketluan/hc-command-comment.vue